import {FlowBlock} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {MeshTypeaheadItem} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshTypeaheadItem';
import {
    IVisualStreamId,
    VisualStreamId,
    VisualStreamIds,
    VisualStreamIdSet
} from '@mintdata-wsp/common/state/ui/visualDesigner/visualData/VisualStreamIds';
import {NameUtil} from '@mintdata-wsp/common/util/NameUtil';
import {FrameEntry} from '@mintdata-wsp/wsp/controllers/visualDesigner/visualData/VisualDataManager';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import bind from 'bind-decorator';
import {observe} from 'mobx';
import {IArraySplice} from 'mobx/lib/types/observablearray';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';
import {SlotLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotLocation';

export class FlowBindingsController
{
    @bind
    public findTypeaheadItems(searchPrefix:string):MeshTypeaheadItem<IVisualStreamId>[]
    {
        const flowBlocks = controllers.ui.flowCanvas.getCurrentFlowBlocks();

        if( !flowBlocks )
            return [];

        const typeaheadItems = flowBlocks
            .filter((block:FlowBlock) => (!block.isDebugBlock))
            .filter((block:FlowBlock) =>
            {
                const title = NameUtil.getInstanceOrBlockName(block);
                const matchesFilter = title.toLowerCase().indexOf(searchPrefix.toLowerCase()) !== -1;

                return matchesFilter;
            })
            .map((block:FlowBlock) =>
            {
                const blockStreams = VisualStreamIds.forBlock(block);
                const title = NameUtil.getInstanceOrBlockName(block);
                const outputStreamSet:VisualStreamIdSet = blockStreams.output as VisualStreamIdSet;

                return MeshTypeaheadItem.forFlowPort(title, outputStreamSet.getStreamIds()[0]);
            });

        return typeaheadItems;
    }

    @bind
    public bindSlotToFlowPort(ctx:IWSPMeshContext, colIndex:number, rowIndex:number, item:MeshTypeaheadItem<IVisualStreamId>):void
    {
        const streamId = item.datum;
        if( streamId.isStreamSet )
        {
            console.error(`Error: streamSet (instead of single stream) passed to FlowBindingsController::bindSlotToFlowPort`);
            return;
        }

        const singleStream = (streamId as VisualStreamId);

        const frameEntries = controllers.ui.visualData.getOrCreateTimeline(singleStream).getFrameEntries();
        this._subscribeToEntries(ctx, frameEntries, colIndex, rowIndex);
        this._applyFrameEntries(ctx, frameEntries, colIndex, rowIndex);
    }

    private _subscribeToEntries(ctx:IWSPMeshContext, frameEntries:FrameEntry[], colIndex:number, rowIndex:number):void
    {
        observe(frameEntries, (change:IArraySplice<FrameEntry> | any) =>
        {
            console.log(`FRAME BINDINGS -- CHANGE!`, change);

            if( change.type === 'splice' )
            {
                const addedFrameEntries:FrameEntry[] = change.added;

                if( addedFrameEntries )
                    this._applyFrameEntries(ctx, addedFrameEntries, colIndex, rowIndex);
            }
        });
    }

    private _applyFrameEntries(ctx:IWSPMeshContext, frameEntries:FrameEntry[], colIndex:number, rowIndex:number)
    {
        for( let entry of frameEntries )
        {
            const frame = entry.frame;
            this._applyFrameToSpreadsheet(ctx, frame, colIndex, rowIndex);
        }
    }

    @bind
    private _applyFrameToSpreadsheet(ctx:IWSPMeshContext, frame:IFrame, colIndex:number, rowIndex:number):void
    {
        const fieldNames = frame.getFieldNames();

        let headerOffsetX = 0;
        for( let fieldName of fieldNames )
        {
            this._setCellText(ctx, colIndex + headerOffsetX, rowIndex, fieldName);
            headerOffsetX++;
        }

        const records = frame.getRecords();
        let offsetX = 0;
        let offsetY = 1; // fieldName(s) took up first row

        for( let record of records )
        {
            for( let fieldName of fieldNames )
            {
                const frameCellValue = record.getCell(fieldName, true);
                const cellValueAsString = frameCellValue.toString();

                this._setCellText(ctx, colIndex + offsetX, rowIndex + offsetY, cellValueAsString);
                offsetX++;
            }

            offsetX = 0;
            offsetY++;
        }
    }

    @bind
    private _setCellText(ctx:IWSPMeshContext, colIndex:number, rowIndex:number, text:string)
    {
        ctx.sheetCtrl.setSlotFormula(ctx.sheetId, new SlotLocation(colIndex, rowIndex), text);

        // const activeSheet = controllers.ui.spreadsheets.mesh.getActiveSheet();
        // console.log(`_setCellText(${colIndex}, ${rowIndex}) => ${text}`);
        // controllers.ui.spreadsheets.slotData.setFormula(activeSheet, colIndex, rowIndex, AString.fromString(text));
    }
}












